import { IGetState, TBoardId } from '../../../types/types';
import { Dispatch, ThunkAction } from '../../../types/actions';
import { boardPatchRest } from './api/helpers/boardPatchRest';

export const boardSetEnableOpenGraphInfo = (
    boardId: TBoardId,
    enableOpenGraphInfo: boolean
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        return dispatch(boardPatchRest(boardId, {enableOpenGraphInfo}));
    };
    return action;
}
